import smoothscroll from "smoothscroll-polyfill";
import AOS from 'aos';
import hamburger from "./../part/hamburger";
import dropdown from "./../part/dropdown";
import fdCarousel from "../part/fdCarousel"
import fdTimeline from "../part/fdTimeline"
import fdReviews from "../part/fdReviews"
import fdHeroSlider from "../part/fdHeroSlider"
import { init as resizeInit } from "../part/resize";

// https://github.com/aFarkas/lazysizes
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

export default {
	init() {
		// JavaScript to be fired on all pages

		AOS.init();

		resizeInit();

		// kick off the polyfill!
		smoothscroll.polyfill();

		// Hamburger event listener
		hamburger();

		// Dropdown
		dropdown();

		// CAROUSEL
		const caraouselSection = document.getElementById('caraouselSection')
		if (typeof(caraouselSection) != 'undefined' && caraouselSection != null){
			fdCarousel();
		}

		// Timeline
		const sliderTimeline = document.getElementById('sliderTimeline')
		if (typeof(sliderTimeline) != 'undefined' && sliderTimeline != null){
			fdTimeline();
		}

		// Reviews Slider
		const sliderReviews = document.getElementById('sliderReviews')
		if (typeof(sliderReviews) != 'undefined' && sliderReviews != null){
			fdReviews();
		}
	
		// Hero Slider
		const sliderHome = document.getElementById('sliderHome')
		if (typeof(sliderHome) != 'undefined' && sliderHome != null){
			fdHeroSlider();
		}
	
	},

	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
